import React from "react"
import Moment from "moment"
import BonusPointsLayout from "./BonusPointsLayout"
import CustomDataTable from "../shared/CustomDataTable"

const columns = [
  { key: 'product_name', label: 'Produto', sortKey: 'product_name' },
  { key: 'points_earned', label: 'Pontos atribuidos', sortKey: 'points_earned'},
  { key: 'user_login', label: 'Jogador', sortKey: 'user_login'},
  {
    key: 'date',
    label: 'Data de atribuição',
    sortKey: 'date',
    render: (_v, item) => new Moment(item.date).format('DD/MM/YYYY'),
  },
];

const sortFn = (data, sort) => {
  const sorted = [...data];
  sorted.sort((a, b) => {
    let valA, valB;
    switch (sort.key) {
      case 'product_name':
        valA = (a.product_name || '').toLowerCase();
        valB = (b.product_name || '').toLowerCase();
        break;
      case 'points_earned':
        valA = Number(a.points_earned);
        valB = Number(b.points_earned);
        break;
      case 'user_login':
        valA = (a.user_login || '').toLowerCase();
        valB = (b.user_login || '').toLowerCase();
        break;
      case 'date':
        valA = new Date(a.date).getTime();
        valB = new Date(b.date).getTime();
        break;
      default:
        return 0;
    }
    if (valA < valB) return sort.direction === 'asc' ? -1 : 1;
    if (valA > valB) return sort.direction === 'asc' ? 1 : -1;
    return 0;
  });
  return sorted;
};

const BonusPointsGivenTable = ({ givenBonusPoints, pagination, onPageChange, page, onOpenAddForm }) => {
  const renderRow = (item, index, className) => {
    const normalizedDate = new Moment(item.date);
    return (
      <tr key={item.id || index} className={`data-table__row ${className}__row`}>
        <td className={`data-table__cell ${className}__cell ${className}__cell--product_name`}>
          {item.product_name}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--points_earned`}>
          {item.points_earned}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--user_login`}>
          {item.user_login}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--date`}>
          {normalizedDate.format('DD/MM/YYYY')}
        </td>
      </tr>
    );
  };

  return (
    <BonusPointsLayout onOpenAddForm={onOpenAddForm}>
      <CustomDataTable
        className="bonus-points-given-table"
        columns={columns}
        data={givenBonusPoints}
        renderRow={renderRow}
        rowKey={(item) => item.id}
        defaultSort={{ key: 'date', direction: 'desc' }}
        sortFn={sortFn}
        pagination={{
          totalPages: pagination.total_pages,
          currentPage: page,
          onPageChange,
        }}
        emptyMessage="Ainda não existem transferencias realizadas."
      />
    </BonusPointsLayout>
  )
}

export default BonusPointsGivenTable
